import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import {
    GrpcClientsContextValue,
    useGrpcClients,
} from '@/contexts/GrpcClientContext'
import { DeletedItemSelection } from '@/generated/Enumerations/DeletedItemSelection_pb'
import { assertNotNullish } from '@/helper/assertNotNullish'
import { parseId } from '@/helper/id'
import {
    detailsQueryKeyPrefix,
    workingTimeModelsQueryKeyPrefix,
} from '@/helper/queryKeyPrefixes'

export const workingTimeModelQueryKeyPrefix = [
    workingTimeModelsQueryKeyPrefix,
    detailsQueryKeyPrefix,
]

export const workingTimeModelOptions = (
    clients: Partial<GrpcClientsContextValue> | null,
    id: string
) =>
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryOptions({
        queryKey: [...workingTimeModelQueryKeyPrefix, id],
        queryFn: async ({ signal }) => {
            assertNotNullish(clients?.workingTimeModel)

            const response = await clients.workingTimeModel.getWorkingTimeModel(
                {
                    id: parseId(id),
                    deletedItemSelection: DeletedItemSelection.NORMAL_ONLY,
                },
                { signal }
            )

            return response
        },
    })

export const useWorkingTimeModel = (id: string) => {
    const clients = useGrpcClients()

    return useSuspenseQuery(workingTimeModelOptions(clients, id))
}
